import { Component } from '@angular/core';
import { ToggleService } from '../../shared/services/toggle.service';

@Component({
  selector: 'app-video-wrapper',
  template: `
    @if (isBunny) {
      <app-bunny-video />
    } @else {
      <app-after-main-game />
    }
  `,
  standalone: false
})
export class VideoWrapperComponent {
  isBunny: boolean;

  constructor(toggleService: ToggleService) {
    this.isBunny = toggleService.isEnabled('bunny');
  }
}
